/* 
 *  Copyright (c) Intel Corporation.  All Rights Reserved.
 *
 * Primary entry point for accessing DataSets
 */
/*--!!!!!ATTENTION!!!!!-----DO NOT DELETE code inside Webpack Macros,it will be used in Analytics SDK for Web */

// #IFDEF WebPack

import { ModuleManager, globalEngine, enableAnalyticsSDKForUWP } from "./Init";
import { logNormal, logInformation, logWarning, logError, logDebug, logConsole, logRawTrack, logTransports, logAutomationError } from "./bootstrap_web_ext";
import {getScriptVariableStore, sendRequestInJSRT, LoadScript } from "./bootstrap_web_ext";
import { engine } from "./engine";
import jsSHA from  "./sha256";
import { getSystemPlugin } from "./common";

// #ENDIF WebPack

function CreateEventHubTransport()
{
	LoadScript('sha256.js');    
    function updateStringWithReplacement (strInput, replacementKey, replacementValue)
    {
        try
        {
            return strInput.replace(replacementKey, replacementValue);
        }
        catch (e)
        {
            logError('updateStringWithReplacement: Exception caught with message: ' + e.message);
            return strInput;
        }
    }

    function Event_Hub_Transport()
    {
        this._apiVersion = null;
        this._servicebusNamespace = null;
        this._eventHubPath = null;
        this._sharedAccessKey = null;
        this._sharedAccessName = null;
        this._sharedAccessToken = null;
        this._tokenCreationTime = null;
        this._timeout = 60;
        this._url = "https://{servicebusNamespace}.servicebus.windows.net/{eventHubPath}/messages?timeout={timeout}&api-version={apiVersion}";
    };
    Event_Hub_Transport.prototype = ModuleManager.create("rest_transport");
    Event_Hub_Transport.prototype.constructor = Event_Hub_Transport;

    Event_Hub_Transport.prototype._setup = function ()
    {
        this._apiVersion = this._config["apiVersion"];
        if (!this._apiVersion)
        {
            logError("Event_Hub_Transport:: Initialize Invalid (unspecified) _apiVersion");
            return false;
        }

        this._servicebusNamespace = this._config["servicebusNamespace"];
        if (!this._servicebusNamespace)
        {
            logError("Event_Hub_Transport:: Initialize Invalid (unspecified) _servicebusNamespace");
            return false;
        }

        this._eventHubPath = this._config["eventHubPath"];
        if (!this._eventHubPath)
        {
            logError("Event_Hub_Transport:: Initialize Invalid (unspecified) _eventHubPath");
            return false;
        }

        this._sharedAccessKey = this._config["sharedAccessKey"];
        if (!this._sharedAccessKey)
        {
            logError("Event_Hub_Transport:: Initialize Invalid (unspecified) sharedAccessKey");
            return false;
        }

        this._sharedAccessName = this._config["sharedAccessName"];
        if (!this._sharedAccessName)
        {
            logError("Event_Hub_Transport:: Initialize Invalid (unspecified) sharedAccessName");
            return false;
        }

        this._tokenRefreshTime = this._config["tokenRefreshTime"];
        if (!this._tokenRefreshTime)
        {
            this._tokenRefreshTime = 1;//hour
        }

        this._updateURL('{servicebusNamespace}', this._servicebusNamespace);
        this._updateURL('{eventHubPath}', this._eventHubPath);
        this._updateURL('{timeout}', this._timeout);
        this._updateURL('{apiVersion}', this._apiVersion);
      
        this._createRESTclientPlugin();
        
        // Version 1 did not support headers
        // Version 2 does not allow having multiple instances, since the Agent name is the same
        if (this.GetVersion() && (this.GetVersion() != '1') && (this.GetVersion() != '2'))
        {
            this._usingRESTclientPlugin = true;
            logInformation('Calling parent class to setup using the restful plugin');
            this._plugin.SetHttpMode('POST');
            var system = getSystemPlugin();
            this._plugin.SetAgentName('McAfee EventHub transmitter_' + system.CreateGUID());
            this._plugin.Connect(this._url);
        }
        else
        {
            this._plugin = null; //Free the plugin if not used
        }

        return true;
    };

    Event_Hub_Transport.prototype._updateURL = function(replacementKey, replacementValue)
    {
        this._url = updateStringWithReplacement(this._url, replacementKey, replacementValue);
    };

    Event_Hub_Transport.prototype._sendUsingRestClient = function(eventDataString)
    {
        try
        {
            var sendResult = this._Send(eventDataString);
            var sendResultObj = JSON.parse(sendResult);

            if (!sendResultObj)
            {
                logError('Event_Hub_Transport::_sendUsingRestClient: Unable to parse result from transmission');
                return null;
            }

            return sendResultObj['statusCode'];//We don't care about anything else in the response
        }
        catch (e)
        {
            logError('Event_Hub_Transport::_sendUsingRestClient: Exception caught with message: ' + e.message);
        }
    };



    Event_Hub_Transport.prototype._sendUsingXmlHttp = function(eventDataString)
    {
        var selectedObjName;
        try
        {
            var xmlHttpCom = ModuleManager.create("xmlHttpComObj");
            
            if (!xmlHttpCom.setup())
            {
                logError('Event_Hub_Transport::_sendUsingXmlHttp: couldnt create a xmlHttpCom');
                return null;
            }

            selectedObjName = xmlHttpCom.getSelectedObjName();
            logInformation('Event_Hub_Transport::_sendUsingXmlHttp: Using ' + selectedObjName);
            xmlHttpCom.open("POST", this._url, false);

            for (var key in this._requestHeaders)
            {
                xmlHttpCom.setRequestHeader(key, this._requestHeaders[key]);
            }

            xmlHttpCom.send(eventDataString);

            var contentTypeResp = xmlHttpCom.getResponseHeader('Content-Type');
            var sendResult = contentTypeResp.match('application/xml') ? true : false;

            if (true === sendResult)
            {
                return '201'; //Marking success
            }

            var allRespHeaders = '';
            try
            {
                allRespHeaders = xmlHttpCom.getAllResponseHeaders();
                allRespHeaders = allRespHeaders.split('\r').join(' ');
                allRespHeaders = allRespHeaders.split('\n').join(' ');
            }
            catch (e)
            {
                //Do nothing
            }

            this._reportExceptionTelemetry(selectedObjName, 'ResponseHeader:' + allRespHeaders, eventDataString);

            return null;
        }
        catch (e)
        {
            logError('Event_Hub_Transport::_sendUsingXmlHttp: Using COM obj (' + selectedObjName + '). Exception caught with message: ' + e.message);
            this._reportExceptionTelemetry(selectedObjName, 'ErrorMsg: ' + e.message, eventDataString);

            return null;
        }
    };

     Event_Hub_Transport.prototype._sendUsingCommonHttpClient = function(eventDataString)
    {
        try
        {
			var sendStatusCode = sendRequestInJSRT(this._url,this._requestHeaders,eventDataString);
            if(sendStatusCode == "201")
                return sendStatusCode;
            else
            {
                logError('Event_Hub_Transport::_sendUsingCommonHttpClient: request failed with '+ sendStatusCode + 'status code');
                return null;
            }
           
        }
        catch (e)
        {
            logError('Event_Hub_Transport::_sendUsingCommonHttpClient. Exception caught with message: ' + e.message);
            return null;
        }
    };

    Event_Hub_Transport.prototype._reportExceptionTelemetry = function (httpComObjName, exceptionMessage, eventDataString)
    {
        try
        {
            var data_collector = ModuleManager.getSingleton("data_collector");
            if(!data_collector.get("Device.Network.Connected"))
            {
                logNormal('_reportExceptionTelemetry: No connection availble. Will not send');
                return;
            }

            if (getScriptVariableStore().Get('sent.analytics_event_hub_transport_error'))
            {
                //We want to send only once.
                return;
            }

            getScriptVariableStore().Set('sent.analytics_event_hub_transport_error', true);

            var eventData = JSON.parse(eventDataString);
            var unique_id = eventData['hit_uniqueid'];

            var record = {
                'UniqueIdentifier': 'analytics_event_hub_transport_error',
                'type': 'event',
                'payload': {
                    'Tracker.Type': 'event',
                    'Event.Category': 'Analytics.Content',
                    'Sub.Category': 'Exception',
                    'Event.Action': 'EventHub.Send.Fail',
                    'Event.Label': httpComObjName,
                    'Hit.Result': exceptionMessage,
                    'Hit.Label.1': unique_id
                }
            };

            logNormal('Sending analytics_event_hub_transport_error event');
            var event_handler = ModuleManager.getSingleton("event_handler");
            event_handler.handleV1Record(record);
        }
        catch (e)
        {
            logError('Event_Hub_Transport::_reportExceptionTelemetry: Exception caught with message' + e.message);
        }

    };

    Event_Hub_Transport.prototype._sanitizeEventData = function (eventDataString)
    {
        try
        {
            var eventObj = JSON.parse(eventDataString);
            var cleanObjData = {};
            for (var item in eventObj)
            {
                cleanObjData[item.toLowerCase()] = eventObj[item];
            }

            return cleanObjData;
        }
        catch (e)
        {
            logError('Event_Hub_Transport::_sanitizeEventData Exception caught with message: ' + e.message);
            return null;
        }
    };

    Event_Hub_Transport.prototype.Send = function (eventDataString)
    {

        //Docs on API calls
        //https://docs.microsoft.com/en-us/rest/api/eventhub/send-event


        try
        {
            var cleanEventData = this._sanitizeEventData(eventDataString);
            var mappings = ModuleManager.getSingleton("mappings");
            var eventData = mappings._map(this._dictionary, cleanEventData, false);
            var mappedEventData = JSON.stringify(this._appendDottedKeys(eventData));

            logDebug('Event_Hub_Transport::Send: Sending using uri (' + this._url + ')');
            var transmissionStatus = false;
            var sendStatusCode = 0;

            var sharedAccessToken = this._createSharedAccessToken(this._url, this._sharedAccessName, this._sharedAccessKey);

            this._AddRequestHeader('Content-Type', 'application/atom+xml;type=entry;charset=utf-8');
            this._AddRequestHeader('Authorization', sharedAccessToken);
            this._AddRequestHeader('Host', this._servicebusNamespace + '.servicebus.windows.net');

            //Eventhub partioning
            var partitionkey = {"PartitionKey": engine.getContextId()};
            this._AddRequestHeader('BrokerProperties', JSON.stringify(partitionkey));

            if (this._usingRESTclientPlugin)
            {
                sendStatusCode = this._sendUsingRestClient(mappedEventData);
            }
            else if (enableAnalyticsSDKForUWP)
            {
                sendStatusCode = this._sendUsingCommonHttpClient(mappedEventData); 
            }
            else
            {
                sendStatusCode = this._sendUsingXmlHttp(mappedEventData);
            }

            logInformation('sendStatusCode: ' + sendStatusCode);

            transmissionStatus = (sendStatusCode == '201') ? true : false;
            if (!transmissionStatus)
            {
                logError('Event_Hub_Transport.Send: Failed to send. Send status code: ' + sendStatusCode);
            }
            
            var uniqueid = cleanEventData['hit.uniqueid'];
            if (this._usingRESTclientPlugin)
            {
                this._transportLog(uniqueid, mappedEventData, transmissionStatus);
            }
            else
            {
                this._transportLog(uniqueid, mappedEventData, transmissionStatus, this.GetName() + '_xmlhttp');
            }
            //We need to check if the status is 201 or not in this case
            return transmissionStatus;
        }
        catch (e)
        {
            logError('Event_Hub_Transport::Send: Exception caught when sending to ('+ this._url +') with message: ' + e.message);
            return false;
        }

        return true;
    };

    Event_Hub_Transport.prototype._appendDottedKeys = function (eventData)
    {
        var attributesToConvert = [
            "csp_clientid",
            "event_category",
            "event_action",
            "event_label",
            "engagement_interactive",
            "engagement_userinitiated",
            "hit_type",
            "hit_uniqueid",
            "hit_severity",
            "hit_label_1",
            "hit_label_2",
            "device_antimalware_provider_enabled",
            "device_os_type",
            "wss_istrial"
        ];

        for (var idx in attributesToConvert)
        {
            var attr = attributesToConvert[idx];
            if (attr in eventData)
            {
                eventData[attr.replace(/_/g, "\.")] = eventData[attr];
            }
        }
        return eventData;
    };

    Event_Hub_Transport.prototype._createSharedAccessTokenParameters = function (uri, saName, saKey)
    {
        try
        {
            if (!uri || !saName || !saKey)
            {
                logError("Event_Hub_Transport::_createSharedAccessToken: Missing required parameter");
                return null;
            }

            var encodedUri = encodeURIComponent(uri);

            var now = new Date();
            var week = 60 * 60 * 24 * 7;
            var ttl = Math.round(now.getTime() / 1000) + week;

            var signature = encodedUri + '\n' + ttl;

            var shaObj = new jsSHA("SHA-256", "TEXT");
            shaObj.setHMACKey(saKey, "TEXT");
            shaObj.update(signature);

            var hmac = shaObj.getHMAC("B64");
            
            var output = {
                'sr': encodedUri,
                'sig': encodeURIComponent(hmac),
                'se': ttl,
                'skn': saName
            };

            return output;
        }
        catch (e)
        {
            logError('Event_Hub_Transport::_createSharedAccessToken: Exception with message: ' + e.message);
            return null;
        }
    };

    Event_Hub_Transport.prototype._tokenExpired = function ()
    {
        try
        {
            if (!this._tokenCreationTime)
            {
                return true;
            }

            var timeNow = new Date();
            var hours = Math.abs(timeNow - this._tokenCreationTime) / 36e5;
            if (hours >= this._tokenRefreshTime)
            {
                this._tokenCreationTime = null;
                return true;
            }
        }
        catch (e)
        {
            logError('Event_Hub_Transport::_tokenExpired Exception caught with message: ' + e.message);
        }
        return false;
    };

    Event_Hub_Transport.prototype._createSharedAccessToken = function (uri, saName, saKey)
    {
        try
        {
            if (this._sharedAccessToken && !this._tokenExpired())
            {
                return this._sharedAccessToken;
            }

            logInformation('Event_Hub_Transport::_createSharedAccessToken: Shared access token expired or not availble. Recreating.');

            this._tokenCreationTime = new Date();
            var tokenParameters = this._createSharedAccessTokenParameters(uri, saName, saKey);

            if (!tokenParameters)
            {
                logError('Event_Hub_Transport::_createSharedAccessToken creating token parameters failed');
                return null;
            }

            this._sharedAccessToken = 'SharedAccessSignature sr=' + tokenParameters['sr'] + '&sig=' + tokenParameters['sig']
               + '&se=' + tokenParameters['se'] + '&skn=' + tokenParameters['skn'];

            return this._sharedAccessToken;
        }
        catch (e)
        {
            logError('Event_Hub_Transport::_createSharedAccessToken: Exception with message: ' + e.message);
            return null;
        }
    };

    var event_hub_transport = new Event_Hub_Transport();
    return event_hub_transport;
}

// register the factory function with ModuleManager
ModuleManager.registerFactory("transport_event_hub", CreateEventHubTransport);
//export  {CreateEventHubTransport};
//globalEngine.FactoryMap["transport_event_hub"] = CreateEventHubTransport;
